<template>
    <base-banner class="bg-red-600 text-white">
        <slot></slot>
    </base-banner>
</template>
